import { Divider, useTheme } from '@material-ui/core';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ImageCarousel from '../../../components/ImageCarousel/ImageCarousel';
import { Modal } from '../../../components/Modal';
import { Spacer } from '../../../components/Spacer';
import { Typography } from '../../../components/Typography';
import { addonPropTypes } from '../../../data/models/Experience';
import { formatCurrency, safeDivision } from '../../../utils/helpers';
import useStyles from './AddonDetailsModalStyles';

// TODO use restaurant's theming
const AddonDetailsModal = ({ onClose, open, addon, isAccommodation }) => {
  const classes = useStyles();
  const theme = useTheme();

  // Need to calculate the full price of the addon, in case some needs to be paid later
  const fullPrice =
    addon?.percentageOfFullPrice < 100
      ? safeDivision(1, addon?.percentageOfFullPrice) * addon?.price * 100
      : addon?.price;

  // TODO get from the addon itself
  const fullDescription = addon?.extraContent?.featureLongText;

  const slides = useMemo(
    () =>
      (addon?.allImages || [])
        .filter((image) => image.active)
        .map((image) => ({
          imageUrl: image.imageUrl,
          caption: '',
        })),
    [addon?.allImages],
  );

  return (
    <Modal open={open} onClose={onClose} style={{ maxWidth: '600px' }}>
      <Spacer direction='vertical' gap={32} className={classes.header}>
        <Typography className={classes.title}>
          {addon?.extraContent?.optionalTitle ?? addon?.name}
        </Typography>

        {addon?.imageUrl && (
          <ImageCarousel
            hoverControls
            slides={slides}
            fitStyle={isAccommodation ? 'cover' : 'contain'}
          />
        )}

        <Spacer direction='vertical' gap={24} className={classes.headerContent}>
          <Typography className={classes.description}>
            {addon?.extraContent?.featureShortText ?? addon?.description}
          </Typography>
          <Typography>
            {formatCurrency(fullPrice, false, '$0', false, true)} per {addon.unit ?? 'item'}
          </Typography>
          <Divider color={theme.colors.dividerColor} />
        </Spacer>

        <Spacer direction='vertical' gap={20}>
          <Typography className={classes.fullDescription}>
            {/* More dangerous stuff */}
            <div dangerouslySetInnerHTML={{ __html: fullDescription }} />
          </Typography>
        </Spacer>
      </Spacer>
    </Modal>
  );
};

AddonDetailsModal.defaultProps = {
  open: false,
  isAccommodation: false,
};

AddonDetailsModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool,
  addon: addonPropTypes.isRequired,
  isAccommodation: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  booking: state.booking,
  obeeBooking: state.obeeBooking,
  restaurant: state.restaurant,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AddonDetailsModal);
